const createLineItemId = (orderLineItem)=>{
    /**
   * Using `window.btoa` here as a slightly naive approach to create a hash of
   * the order line item which can be used as an identifier.
   */ return window.btoa(JSON.stringify(orderLineItem));
};

export { createLineItemId };
//# sourceMappingURL=create-line-item-id.js.map
